import { render, staticRenderFns } from "./CodeModal.vue?vue&type=template&id=3cd180c4&scoped=true"
import script from "./CodeModal.vue?vue&type=script&lang=js"
export * from "./CodeModal.vue?vue&type=script&lang=js"
import style0 from "./CodeModal.vue?vue&type=style&index=0&id=3cd180c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd180c4",
  null
  
)

export default component.exports